/* eslint-disable */
// GENERATED by `npm run help:build` from docs/user/. Do not edit.
//
// Edit the Markdown source instead. `generated-is-fresh.spec.ts` fails when this file and its
// source disagree (SC-009), which is what makes committing derived output safe — the web image is
// built with `modules/front-end` as its context and cannot see `docs/user/` at all (research R-001).
//
// The light half of the manifest: id, path and title only, with no HTML in it at all, so importing
// this — as `help.routes.tsx` and `help-shell.tsx` both do, eagerly — never pulls the guide's
// actual prose into a chunk that ships before anyone opens `/help`. That prose is `./pages`.
export interface HelpPage {
  /** The source file's basename, lowercased, without `.md`. */
  readonly id: string;
  /** The route path under `/help`. The index is `''`. */
  readonly path: string;
  readonly title: string;
}

/** Reading order: the index, then the order `docs/user/README.md` links them, then the rest. */
export const HELP_PAGES: readonly HelpPage[] = [
  { id: 'readme', path: '', title: "CompleteMe user guide" },
  { id: 'quick-add', path: 'quick-add', title: "Quick add" },
  { id: 'getting-started', path: 'getting-started', title: "Getting started" },
  { id: 'workflow', path: 'workflow', title: "The workflow, and where each part of it lives" },
  { id: 'screens', path: 'screens', title: "The screens" },
  { id: 'feeds', path: 'feeds', title: "Feeds — your actions in a calendar or feed reader" },
  { id: 'coming-from-tracks', path: 'coming-from-tracks', title: "Coming from Tracks" },
  { id: 'install-as-an-app', path: 'install-as-an-app', title: "Installing CompleteMe as an app" },
  { id: 'running-an-instance', path: 'running-an-instance', title: "Running an instance" },
  { id: 'limits', path: 'limits', title: "What CompleteMe deliberately does not do" },
];
